/**
 * @fileoverview This module encapsulates HelpHero initialization and provides
 * an initialized instance that is ready to use.
 */

import initHelpHero from "helphero";
export default initHelpHero(process.env.REACT_APP_HELP_HERO_ID as string);
